import type { BaseQueryFn } from "@reduxjs/toolkit/query";

// Tells the server which bundle is talking to it, so it can work out which
// versions are actually in use before anyone raises the forced-update floor
// (services/src/modules/client-version/). The version code is package.json's
// version with the dots stripped, matching the mobile convention
// (1.0.016 -> 10016). Diagnostics only — nothing is authorized on these.
const CLIENT_HEADERS = {
  "x-client-platform": "web",
  "x-client-version": __APP_VERSION__.replace(/\./g, ""),
};

export const graphqlBaseQuery =
  ({ url }: { url: string }): BaseQueryFn =>
  async ({ body }) => {
    try {
      const accessToken =
        localStorage.getItem("accessToken");

      const result = await fetch(url, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",

          ...CLIENT_HEADERS,

          ...(accessToken && {
            Authorization: `Bearer ${accessToken}`,
          }),
        },

        body: JSON.stringify(body),
      });

      const json = await result.json();

      if (json.errors?.length) {
        return {
          error: json.errors[0],
        };
      }

      return {
        data: json.data,
      };
    } catch (error) {
      return {
        error,
      };
    }
  };